<div class="fdes-dialog">
  <div class="fdes-dialog__head">
    <span class="fdes-dialog__ic"><mat-icon>eco</mat-icon></span>
    <div class="fdes-dialog__titles">
      <div class="fdes-dialog__title">{{ 'fdes_dialog_title' | translate }}</div>
      <div class="fdes-dialog__sub">{{ subtitle }}</div>
    </div>
    <button type="button" class="fdes-dialog__close" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <div class="fdes-dialog__body" *ngIf="view === 'form'" [formGroup]="form">
    <ng-container *ngIf="canGenerate && !blockingMessage">
      <!-- Avant les champs : le corps du dialogue est reconstruit au retour de l'écran de chargement, donc
           replacé en haut, et un refus rendu en fin de formulaire restait hors écran. -->
      <div class="fdes-checks err" *ngIf="errorMessage">
        <div class="fdes-checks__head">
          <mat-icon>error_outline</mat-icon>
          <span>{{ 'fdes_dialog_generate_error' | translate }}</span>
        </div>
        <div class="fdes-checks__row" *ngFor="let line of errorLines">
          <mat-icon class="err">cancel</mat-icon>
          <div class="fdes-checks__detail">{{ line }}</div>
        </div>
      </div>

      <div class="seve-field">
        <label class="seve-label">{{ 'fdes_dialog_formula_type_label' | translate }}</label>
        <select class="seve-select" formControlName="type">
          <option value="">{{ 'fdes_dialog_formula_type_placeholder' | translate }}</option>
          <option *ngFor="let t of formulaTypes" [value]="t.code">{{ t.label }}</option>
        </select>
        <div class="fdes-field-error" *ngIf="formCrls.type.invalid && formCrls.type.touched">{{ 'fdes_dialog_type_error' | translate }}</div>
      </div>

      <div class="seve-field">
        <label class="seve-label">{{ 'fdes_dialog_thickness_label' | translate }}</label>
        <div class="fdes-thick">
          <input class="seve-input seve-input--mono" type="number" formControlName="thickness" min="0" placeholder="6" />
          <span class="fdes-thick__unit">cm</span>
        </div>
        <div class="fdes-field-error" *ngIf="formCrls.thickness.invalid && formCrls.thickness.touched">{{ 'fdes_dialog_thickness_error' | translate }}</div>
      </div>

      <div class="fdes-group">
        <div class="fdes-group__title"><mat-icon>place</mat-icon>{{ 'fdes_dialog_site_company' | translate }}</div>

        <div class="seve-field">
          <label class="seve-label">{{ 'fdes_dialog_site_label' | translate }}</label>
          <div class="seve-radiogroup">
            <label class="seve-radio"><input type="radio" formControlName="site" value="default" />{{ 'fdes_dialog_site_default' | translate }}</label>
            <label class="seve-radio"><input type="radio" formControlName="site" value="specific" />{{ 'fdes_dialog_site_specific' | translate }}</label>
          </div>
        </div>

        <div class="seve-field" *ngIf="!isDefaultSite">
          <label class="seve-label">{{ 'fdes_dialog_location_label' | translate }}</label>
          <input class="seve-input" formControlName="location" [placeholder]="'fdes_dialog_location_placeholder' | translate" />
          <div class="fdes-field-error" *ngIf="formCrls.location.invalid && formCrls.location.touched">{{ 'fdes_dialog_location_error' | translate }}</div>
        </div>

        <div class="seve-field">
          <label class="seve-label">{{ 'fdes_dialog_distance_label' | translate }}</label>
          <div class="fdes-thick">
            <input class="seve-input seve-input--mono" type="number" formControlName="distance" min="0" placeholder="35" />
            <span class="fdes-thick__unit">km</span>
          </div>
          <div class="fdes-field-error" *ngIf="formCrls.distance.invalid && formCrls.distance.touched">{{ 'fdes_dialog_distance_error' | translate }}</div>
        </div>

        <div class="seve-field" *ngIf="data.needsDeclarantAddress">
          <label class="seve-label">{{ 'fdes_dialog_address_label' | translate }}</label>
          <input class="seve-input" formControlName="declarantAddress" [placeholder]="'fdes_dialog_address_placeholder' | translate" />
          <div class="fdes-field-error" *ngIf="formCrls.declarantAddress.invalid && formCrls.declarantAddress.touched">{{ 'fdes_dialog_address_error' | translate }}</div>
        </div>

        <div class="seve-field">
          <label class="seve-label">{{ 'fdes_dialog_logo_label' | translate }}</label>
          <div class="fdes-ftp" [class.has-file]="logoFileName" (click)="logoPicker.click()">
            <span class="fdes-ftp__ic fdes-ftp__ic--logo"><mat-icon>image</mat-icon></span>
            <div class="fdes-ftp__txt">
              <div class="fdes-ftp__title">{{ logoFileName || ('fdes_dialog_logo_attach' | translate) }}</div>
              <div class="fdes-ftp__sub">{{ logoFileName ? ('fdes_dialog_logo_ready' | translate) : ('fdes_dialog_logo_hint' | translate) }}</div>
            </div>
            <mat-icon class="fdes-ftp__act">{{ logoFileName ? 'check' : 'add' }}</mat-icon>
          </div>
          <input #logoPicker type="file" accept="image/*" hidden (change)="onLogoSelected(logoPicker.files)" />
        </div>
      </div>

      <div class="seve-field">
        <label class="seve-label">{{ 'fdes_dialog_ftp_label' | translate }}</label>
        <div class="fdes-ftp" [class.has-file]="ftpFileName || data.proofFileName" (click)="ftpPicker.click()">
          <span class="fdes-ftp__ic"><mat-icon>picture_as_pdf</mat-icon></span>
          <div class="fdes-ftp__txt">
            <div class="fdes-ftp__title">{{ ftpFileName || data.proofFileName || ('fdes_dialog_ftp_attach' | translate) }}</div>
            <div class="fdes-ftp__sub">
              {{ ftpUploading ? ('fdes_dialog_ftp_uploading' | translate) : ftpFileName ? ('fdes_dialog_ftp_ready' | translate) : data.proofFileName ? ('fdes_dialog_ftp_existing' | translate) : ('fdes_dialog_ftp_hint' | translate) }}
            </div>
          </div>
          <mat-icon class="fdes-ftp__act">{{ ftpFileName || data.proofFileName ? 'check' : 'add' }}</mat-icon>
        </div>
        <input #ftpPicker type="file" accept="application/pdf" hidden (change)="onFtpSelected(ftpPicker.files)" />
        <div class="fdes-field-error" *ngIf="ftpError">{{ 'fdes_dialog_ftp_error' | translate }}</div>
      </div>
    </ng-container>

    <div class="fdes-checks err" *ngIf="blockingMessage">
      <div class="fdes-checks__head">
        <mat-icon>error_outline</mat-icon>
        <span>{{ 'fdes_dialog_unavailable' | translate }}</span>
      </div>
      <div class="fdes-checks__row" *ngFor="let line of blockingLines">
        <mat-icon class="err">cancel</mat-icon>
        <div class="fdes-checks__detail">{{ line }}</div>
      </div>
    </div>

    <div class="fdes-checks warn" *ngIf="isNotAdherent && !blockingMessage">
      <div class="fdes-checks__head">
        <mat-icon>info_outline</mat-icon>
        <span>{{ 'fdes_dialog_not_adherent' | translate }}</span>
      </div>
    </div>

    <!-- Historique visible dès l'ouverture : sans lui, une organisation qui n'est plus adhérente n'aurait
         aucun moyen d'atteindre ses FDES passées, que le PO veut garder accessibles. -->
    <ng-container *ngTemplateOutlet="historyList"></ng-container>
  </div>

  <div class="fdes-dialog__body fdes-loading" *ngIf="view === 'loading'">
    <mat-spinner diameter="40"></mat-spinner>
    <div class="fdes-loading__txt">{{ 'fdes_dialog_loading_txt' | translate }}</div>
    <div class="fdes-loading__sub">{{ 'fdes_dialog_loading_sub' | translate }}</div>
  </div>

  <div class="fdes-dialog__body" *ngIf="view === 'success'">
    <div class="fdes-success__banner">
      <span class="fdes-success__ic"><mat-icon>check_circle</mat-icon></span>
      <div>
        <div class="fdes-success__title">{{ 'fdes_dialog_success_title' | translate }}</div>
        <div class="fdes-success__sub">{{ 'fdes_dialog_success_sub' | translate }}</div>
      </div>
    </div>

    <div class="fdes-checks warn" *ngIf="warnings.length">
      <div class="fdes-checks__head">
        <mat-icon>info_outline</mat-icon>
        <span>{{ 'fdes_dialog_warnings_title' | translate }}</span>
      </div>
      <div class="fdes-checks__row" *ngFor="let w of warnings">
        <mat-icon class="warn">warning_amber</mat-icon>
        <div class="fdes-checks__detail">{{ w }}</div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="historyList"></ng-container>
  </div>

  <div class="fdes-dialog__foot" *ngIf="view === 'form'">
    <span class="fdes-dialog__hint" *ngIf="canGenerate && !blockingMessage">{{ isComplete ? ('fdes_dialog_hint_complete' | translate) : ('fdes_dialog_hint_incomplete' | translate) }}</span>
    <span class="seve-spacer"></span>
    <button class="seve-btn seve-btn--neutral" (click)="close()">{{ (canGenerate && !blockingMessage ? 'common_btn_cancel' : 'fdes_dialog_done_btn') | translate }}</button>
    <button class="seve-btn seve-btn--primary" *ngIf="canGenerate && !blockingMessage" (click)="generate()"><mat-icon>eco</mat-icon>{{ 'fdes_dialog_generate_btn' | translate }}</button>
  </div>

  <div class="fdes-dialog__foot" *ngIf="view === 'success'">
    <span class="seve-spacer"></span>
    <button class="seve-btn seve-btn--primary" (click)="close()">{{ 'fdes_dialog_done_btn' | translate }}</button>
  </div>

  <ng-template #historyList>
    <div class="fdes-history" *ngIf="history.length">
      <div class="fdes-history__head">
        <mat-icon>history</mat-icon><span>{{ 'fdes_dialog_history_title' | translate }}</span>
      </div>
      <div class="fdes-history__row" *ngFor="let h of history">
        <span class="fdes-history__type">{{ h.formulaType }}</span>
        <span class="fdes-history__user">{{ h.creator }}</span>
        <span class="fdes-history__date num">{{ h.generatedDate | date: 'dd/MM/yyyy — HH:mm' }}</span>
        <mat-icon class="fdes-history__dl" *ngIf="h.excelRelativePath" (click)="download(h, 'excel')" [title]="'fdes_dialog_download_btn' | translate">download</mat-icon>
        <mat-icon class="fdes-history__dl" *ngIf="h.pdfRelativePath" (click)="download(h, 'pdf')" [title]="'fdes_dialog_download_btn' | translate">picture_as_pdf</mat-icon>
        <mat-icon class="fdes-history__dl" *ngIf="!h.pdfRelativePath && h.wordRelativePath" (click)="download(h, 'word')" [title]="'fdes_dialog_download_btn' | translate">description</mat-icon>
        <mat-icon class="fdes-history__dl" *ngIf="h.xmlRelativePath" (click)="download(h, 'xml')" [title]="'fdes_dialog_download_xml_btn' | translate">code</mat-icon>
        <mat-icon class="fdes-history__dl" *ngIf="h.attestationRelativePath" (click)="download(h, 'attestation')" [title]="'fdes_dialog_download_btn' | translate">verified</mat-icon>
      </div>
    </div>
  </ng-template>
</div>
